module.exports = __webpack_public_path__ + "img/root110.09a41ef6.png";